import { forwardRef } from 'react';

import { ElipsisTooltip } from '../../common/ElipsisTooltip';
import { ReactSortable } from 'react-sortablejs';
import { SIGN_IN_ROUTE, SIGNUP_ROUTE } from '../../constants/routePathConstants';
import ShareButton from './ShareButton';
import { VideoSectionUI } from './VideoSectionUI';
import { navigate } from '../../helpers/projectHelper';
import { LINKED_PRODUCT_DATA } from '../subscriptionComponents/subscriptionHelper';
import { isIphoneIOS } from '../../helpers/jsHelper';
import { useUserContext } from '../../contexts/UserContext';

export const VideoTabUI = ({
  list = [],
  loading,
  setList,
  isEditor,
  handleOrder,
  actionMenu,
  isPublicPage,
  currentUser,
  isVideoEnabled,
  activePlan,
  activeTab,
  setActiveTab,
  availableProductCount,
  onShareClick,
  isPackProduct,
}) => {
  const { isGuestUser, isGuestLogin } = useUserContext();
  
  if (list.length === 0) return null;

  const dataList = list.map((a) => {
    return (
      <li className="nav-item" key={a?.id}>
        <ElipsisTooltip title={a?.name}>
          {({ ref, onMouseEnter, onMouseLeave }) => (
            <button
              ref={ref}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              type="button"
              className={`nav-link bg-transparent ${activeTab?.id === a?.id ? 'active' : ''}`}
              onClick={() => setActiveTab(a)}>
              {a?.name}
            </button>
          )}
        </ElipsisTooltip>
      </li>
    );
  });

  return (
    <div className="video-tab-container">
      <div className="video-tabs">
        {isEditor ? (
          <ReactSortable
            expand={true}
            tag={CustomComponent}
            list={list}
            onSort={(e) => handleOrder(e, activeTab?.type)}
            setList={isEditor ? setList : () => {}}>
            {dataList}
          </ReactSortable>
        ) : (
          <ul className="nav nav-tabs">{dataList}</ul>
        )}

        {!isGuestLogin &&
        !isGuestUser() &&
        (isPackProduct ||
          (!isPackProduct && activeTab?.type !== LINKED_PRODUCT_DATA.PANNING_VIDEO)) ? (
          <ShareButton
            className="share_button small"
            loading={loading}
            onClick={
              isPublicPage && !currentUser
                ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
                : isVideoEnabled
                ? null
                : (!activePlan && availableProductCount === 0) || availableProductCount === 0
                ? isPackProduct && activeTab?.pack_organization
                  ? false
                  : onShareClick
                : null
            }
            menu={actionMenu}
          />
        ) : null}
      </div>
      {list.map(({ id, url, mpd_file }) => (
        <VideoSectionUI
          key={id}
          active={activeTab?.id === id}
          id={id}
          url={isIphoneIOS() ? url || mpd_file : mpd_file || url}
        />
      ))}
    </div>
  );
};

const CustomComponent = forwardRef((props, ref) => {
  return (
    <ul className="nav nav-tabs" ref={ref}>
      {props.children}
    </ul>
  );
});
